import { useState, useEffect, useRef } from "react";
// import { useInView } from "react-intersection-observer";
import ReactGA from "react-ga4";
import Page from "../page/page";

import "./teambuildingPage.scss";
import classnames from "classnames";
import { useMediaQuery } from "@react-hook/media-query";
import classNames from "classnames";

const TeambuildingPage = () => {
  const isPortrait = useMediaQuery("only screen and (orientation: portrait)");

  const targetRef = useRef(null);

  const nav = () => {
    //@ts-ignore
    targetRef?.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Influence Page",
    });
  }, []);

  return (
    <Page
      style={{
        paddingBottom: "0px",
        background: "url(./assets/world/eaux_calmes_miniature.png)",
      }}
      className="teamBuildingPage"
    >
      <div className={classnames("welcomeBigtext", "sectionZero")}>
        {isPortrait ? (
          <>
            <span className="welcomeBigText2">Le team </span>
            {/* <span className="welcomeBigText1">la Baba - </span> */}
            <div className="welcomeBigText3">Boxing</div>
            <div className="welcomeHint1">Groupes de 6 à 30</div>
            <div className="welcomeHint2">Partout en France </div>
          </>
        ) : (
          <>
            <span className="welcomeBigText2">Le team</span>{" "}
            {/* <span className="welcomeBigText1">la Baba -</span> */}
            <div className="welcomeBigText3">Boxing !</div>
            <div className="welcomeHint1">Groupes de 6 à 30</div>
            <div className="welcomeHint2">Partout en France </div>
          </>
        )}
      </div>
      <div className="firstPagePlaceholder" />
      <div className="sectionTwo">
        <div className="presenter">
          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">
              {" "}
              Des coachs sportifs
            </div>
            <div className="welcomeBigText5 presenterText"> certifiés </div>
            <img
              className="explainImage"
              src="./teambuildings/teambuilding1.png"
            />
          </div>

          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">
              {" "}
              Un parcours d'activités
            </div>
            <div className="welcomeBigText5 presenterText">
              variées et inédites
            </div>
            <img
              className="explainImage"
              src="./teambuildings/teambuilding2.png"
            />
          </div>

          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">
              {" "}
              Des espaces partenaires
            </div>
            <div className="welcomeBigText5 presenterText">
              {" "}
              partout en France
            </div>
            <img
              className="explainImage"
              src="./teambuildings/teambuilding3.png"
            />
          </div>
        </div>
      </div>

      <div className="sectionOne">
        <div className="videoAndBannersContainer">
          <div className="videoTitle">
            {/* Le teambuilding Shotam, c'est bien plus que de la réalité virtuelle.
            <br />
            <br />
            C'est un parcours initiatique complet imprégné de l'esprit des arts
            martiaux.
            <br />
            <br />
            Travailler le lâcher prise, l'affirmation de soi, l'écoute de
            l'autre ?
            <br />
            <br /> La réalité virtuelle nous permet de réinventer les sports de
            combat, en permettant une approche inédite et ludique. */}
            Le teambuilding Shotam, c'est bien plus que de la réalité virtuelle
            🥽.
            <br />
            <br />
            C'est un parcours initiatique complet🌟, à travers plusieurs
            ateliers, imprégné de l'esprit des arts martiaux 🥊.
            <br />
            <br />
            Travailler le lâcher prise 🧘, l’affirmation de soi 💪, l’écoute de
            l'autre 👂🤝 ?
            <br />
            <br />
            La réalité virtuelle 🎮 nous permet de réinventer les sports de
            combat ⚔️, avec une approche inédite et ludique 😃.
            {/* <div className="arrowDown"></div>
            <div className="arrowDown2"></div>{" "} */}
          </div>
          {/* <div className="videoWrapper">
            {isPortrait ? (
              <iframe
                width="100%"
                height="600"
                src="https://www.youtube.com/embed/ESmcMxs9xCw"
                title="Shotam : Trailer"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
              ></iframe>
            ) : (
              <div className="trailerContainer">
                <iframe
                  width="500"
                  height="282"
                  // src="https://www.youtube.com/embed/RTw6ekGqoyQ"
                  src="https://www.youtube.com/embed/CByvdQuk9W4"
                  title="Shotam : Trailer"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                ></iframe>
              </div>
            )}
          </div> */}
        </div>
      </div>

      <div className={classnames("sectionTwo", "sectionThree")} ref={targetRef}>
        <div style={{ width: "100% ", textAlign: "center", marginTop: 50 }}>
          Contactez-nous pour en savoir plus sur notre offre de teambuilding, et
          le détail complet de nos activités.
        </div>
        <a
          className={classNames("mailLink", "showBookingButton")}
          href="mailto:contact@shotam.com"
        >
          contact@shotam.app
        </a>
        {/* <div className="presenter">
          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText"> Collaborez </div>
            <div className="welcomeBigText5 presenterText"> en équipe </div>
            <div className="imageAndTextContainer">
              <img
                className="explainImage"
                src="./teambuildings/teamplay.png"
              />
              <div className="imageExplanation">
                Élaborez ensemble votre stratégie d'attaque/défense en fonction
                de vos pouvoirs respectifs !
              </div>
            </div>
          </div>

          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">Brûlez</div>
            <div className="welcomeBigText5 presenterText"> des calories</div>
            <div className="imageAndTextContainer">
              <img className="explainImage" src="./teambuildings/motion.png" />
              <span className="imageExplanation">
                Das l'arène Shotam, tous vos mouvements deviennent un
                superpouvoir !
              </span>
            </div>
          </div>

          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">Amusez-vous </div>
            <div className="welcomeBigText5 presenterText"> comme jamais !</div>
            <div className="imageAndTextContainer">
              <img className="explainImage" src="./teambuildings/fun.png" />
              <span className="imageExplanation">
                Qui n'a jamais rêvé de devenir un superhéros ?
              </span>
            </div>
          </div>
        </div> */}
      </div>
    </Page>
  );
};

export default TeambuildingPage;
